import React from "react";
import { Title } from "./LoadingElements";

const Loading = () => {
  return <Title>Loading...</Title>;
};

export default Loading;
